// extracted by mini-css-extract-plugin
export default {"page":"PageRenderer_page__P1Mkf"};